import Image from 'next/image';
import { KeyboardUpIconProps } from './types';

const CheckCheckboxIcon = ({ className }: KeyboardUpIconProps) => {
  return (
    <Image
      src={'/marketplace-static/images/icons/checkformIcon.svg'}
      alt={'checkbox-icon'}
      width={24}
      height={24}
      className={className}
    />
  );
};

export default CheckCheckboxIcon;
